import { route } from 'quasar/wrappers';
import { inject } from 'vue';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import AuthService from 'src/services/AuthService';
import routesConfig from './routesConfig';
import logger from "src/logger";
import { UserInfoStore } from 'src/types';
import { useQuasar } from 'quasar'
import { usePostHog } from "src/composables/posthog/usePosthog";
import { useAuth } from 'src/composables/auth/useAuth';
import { useAuthStore } from 'src/stores/auth-store';

type AuthStoreType = ReturnType<typeof useAuthStore>;

const { posthog } = usePostHog() || {};

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeResolve( async (to, from) => {
    const userInfoStore = inject('userInfoStore') as UserInfoStore;
    const authStore = inject('authStore') as AuthStoreType;
    const $q = useQuasar();

    logger.debug({
      userId: userInfoStore.id,
      isEmailVerified: userInfoStore.is_email_verified,
      isAuthenticated: authStore.isAuthenticated,
      to: to.path,
      from: from.path
    }, 'User navigating - resolve route');
  
    // Special case for Google Auth redirect
  if (to.query.google_auth_success === 'true') {
    console.log('Detected Google Auth redirect, attempting token refresh');
    
    try {
      // Use your existing refreshToken function
      const { refreshToken } = useAuth();
      const result = await refreshToken(userInfoStore.id === '' ? true : false);
      
      if (result.success) {
        console.log('Google Auth login successful');
        authStore.setIsAuthenticated(true);

        // Remove the query parameter but keep other parameters
        const query = { ...to.query };
        delete query.google_auth_success;
        
        // Redirect to same page without the special parameter
        return {
          path: to.path,
          query: Object.keys(query).length > 0 ? query : undefined
        };
      }
    } catch (error) {
      console.error('Failed to authenticate after Google redirect', error);
      // Continue with normal flow if refresh fails
    }
  }
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
      logger.debug({ path: to.path, isAuthenticated: authStore.isAuthenticated}, 'Redirect to login due to unauthenticated access attempt');
      // Maintain the invite query if present
      return {
          path: to.query.invite ? routesConfig.signup : routesConfig.signin,
          query: to.query.invite ? { invite: to.query.invite } : { redirect: to.fullPath }
      };
  }

    // Handle authenticated state
    if (authStore.isAuthenticated && userInfoStore.id) {
      // Identify users (link anonymous ID to distinct ID)
      if (process.env.VITE_ENV === 'prod' || process.env.VITE_ENV === 'prod-china') {
        posthog.identify(userInfoStore.id,
        { email: userInfoStore.email,
          name : userInfoStore.firstName + '' + userInfoStore.lastName, }
      )
    }

      if( to.path === routesConfig.zoomLoginPage) {
        console.log('authenticated zoomLoginPage')
        return true
      }
        // allow users who just signed up sign up again, avoid loop
        if (!userInfoStore.is_email_verified && to.path === routesConfig.signup && to.query.invite) {
          console.log('authenticated.0')
          return true
        }
        // allow users who just signed up to see verify email message
        if (!userInfoStore.is_email_verified && to.path === routesConfig.verifyEmailMessage && from.path === routesConfig.signup) {
          console.log('authenticated.1')
          return true
        }
        if (!userInfoStore.is_email_verified && to.path !== routesConfig.verifyEmailMessage && to.name !== 'emailVerification' &&  to.name !== 'enrolment') {
          console.log('authenticated 1')
            logger.debug({ userId: userInfoStore.id, isEmailVerified: userInfoStore.is_email_verified }, 'Authenticated user with unverified email');
            return {
                path: routesConfig.verifyEmailMessage,
                query: to.query
            };
        }
        if (to.query.invite) {
          console.log('authenticated 2');
          logger.debug({ path: to.path, invite: to.query.invite }, 'Authenticated user including invite');
          AuthService.enrollStudent(userInfoStore.id, to.query.invite.toString())
            /*.catch((error) => {
              $q.notify({
                type: 'negative',
                message: error.response?.data?.error,
              });
            });*/
          return { path: routesConfig.home };


      }
      if (to.name === 'petSelection' && (userInfoStore.type === 'teacher' || userInfoStore.accountType === 'non_gamified')) {
        return {
          path: routesConfig.home,
          query: to.query
      };
      }

         // Handle redirection for authenticated users on redirectIfAuth pages
        if (to.meta.redirectIfAuth) {
          console.log('authenticated 3')
            if (authStore.isAuthenticated) {
                logger.debug({ path: to.path }, 'Redirect to home due to redirectIfAuth');
                console.log('Redirect to home due to redirectIfAuth' )
                return { path: routesConfig.home, query: to.query };
            }
        }
        return true;
    }

    if (!authStore.isAuthenticated && to.path === routesConfig.verifyEmailMessage) {
      console.log('authenticated 4')
      logger.debug({ path: to.path }, 'Redirect to login due to unauthenticated access attempt');
      return { path: routesConfig.signin };
    }
  console.log('else')
  return true;
});

  return Router;
});
